export const gamecode = {
    rolesCanShowBannerInfo: []
}